<template lang="html">
  <div style="height: 100vh;">
    <!-- <p>{{$vssHeight}}</p> -->
    <v-layout row wrap justify-center align-center style="height: 100vh;">
      <v-progress-circular :width="8" size="90" color="primary" :indeterminate="progress"></v-progress-circular>
    </v-layout>
  </div>
</template>

<script>
import VueScreenSize from 'vue-screen-size'
export default {
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    VueScreenSize
  },
  data () {
    return {
      progress: true
    }
  },
  mounted () {
    var me = this
    setInterval(function () {
      // console.log('update tokenuser')
      // console.log(this.$vssHeight)
      if (window.innerWidth < 960) {
        if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
          me.$router.push('/mobile/room/' + me.$route.params.roomid)
        }
      } else {
        if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
          me.$router.push('/chat/room/' + me.$route.params.roomid)
        }
      }
    }, 4000);
  },
  created () {
    this.progress = true
    // var me = this
    // setInterval(function () {
    //   if (window.innerWidth < 960) {
    //     if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
    //       me.$router.push('/mobile/room/' + me.$route.params.roomid)
    //     }
    //   } else {
    //     if (window.location.pathname === '/mobile/progress/' + me.$route.params.roomid) {
    //       me.$router.push('/chat/room/' + me.$route.params.roomid)
    //     }
    //   }
    // }, 3000);
  },
  watch: {
    '$vssHeight' () {
      // console.log(this.$vssHeight)
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/ProgressLayout.vue